import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Check } from "lucide-react";
import LogoBlue from "../../assets/icons/peppa_logo_blue.svg";
import { trackEvent, trackGoal } from "../../lib/matomo";

export default function BillingSuccess() {
  const navigate = useNavigate();
  useEffect(() => {
    try { trackEvent("billing", "success_page_viewed"); } catch (_) { }
    // Optional Matomo goal (configure goal id via env)
    try {
      const goalId = Number(process.env.REACT_APP_MATOMO_GOAL_BILLING_SUCCESS);
      if (Number.isFinite(goalId)) trackGoal(goalId);
    } catch (_) { }
  }, []);

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-emerald-50 via-background to-background dark:from-emerald-950/40 dark:via-background dark:to-background flex items-center justify-center px-4">
      <div className="absolute inset-x-0 -top-20 h-72 bg-[radial-gradient(40%_60%_at_50%_0%,rgba(16,185,129,0.25),transparent)] pointer-events-none" />
      <Card className="max-w-lg w-full shadow-xl border-muted">
        <CardHeader>
          <div className="flex items-center justify-between mb-2">
            <img src={LogoBlue} alt="Peppa" className="h-6" />
          </div>
          <div className="flex items-start gap-4">
            <div className="h-12 w-12 rounded-full bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center shadow-md">
              <Check className="h-7 w-7 text-white" />
            </div>
            <div>
              <CardTitle className="text-foreground text-2xl">Paiement confirmé !</CardTitle>
              <CardDescription className="mt-1">Merci pour votre confiance.</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="rounded-lg border-muted bg-muted/30 p-3 text-sm text-foreground/80">
              Astuce: pensez à fixer un objectif précis à votre prochain chat pour des réponses encore plus utiles.
            </div>
            <div className="pt-2">
              <Button className="w-full h-11 text-base" onClick={() => navigate("/", { replace: true })}>Retour à l’accueil</Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}


